<template>
    <div>
        <app-header></app-header>
        <div class="bg--img bg--dtg">
            <h1 class="text-center pad-top--xl z-up text-white text-caps">
                DTG Printing
            </h1>
            <h5 class="text-center text-white pad-top--large pad-bottom--xl text-caps">
                <router-link to="/contact-us" class="text-white">
                    Get in touch now for a free quote
                </router-link>
            </h5>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--lilac" style="margin-top:-10px">
            <div class="cell small-12 medium-8">
                <p class="pad--large feature-text">
                    DTG is an ideal solution for printing small to medium quantity orders and can
                    produce excellent results when printing onto garments made from a predominantly
                    cotton fabric. DTG can print outstanding full colour designs, photos and
                    illustrations at high resolutions. The main disadvantage to this method is that
                    pantone colours cannot be matched CMYK is used instead to simulate colours.
                </p>
            </div>
            <div class="cell small-12 medium-4">
                <div class="pad--large">
                    <img src="../../../static/images/customisation/dtg-bg.png" alt="" />
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--lilac-dk">
            <div class="cell small-12 medium-4">
                <div class="zoom-image">
                    <img src="../../../static/images/customisation/dtg-example.png" alt="" />
                </div>
            </div>
            <div class="cell small-12 medium-4">
                <div class="zoom-image">
                    <img src="../../../static/images/customisation/dtg-example-2.png" alt="" />
                </div>
            </div>
            <div class="cell small-12 medium-4">
                <div class="zoom-image">
                    <img src="../../../static/images/customisation/dtg-example-3.png" alt="" />
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--swoosh-top-right">
            <div class="cell small-12 medium-8 medium-offset-2 text-center">
                <span class="image-decoraction">
                    <img width="70px" src="../../../static/images/customisation/time-money.png" alt="" />
                </span>
                <span class="image-decoraction">
                    <img width="80px" src="../../../static/images/customisation/stopwatch.png" alt="" />
                </span>
                <span class="image-decoraction">
                    <img width="60px" src="../../../static/images/customisation/knowledge.png" alt="" />
                </span>
                <h2 class="feature-heading pad-top pad-bottom">Quick - Cost effective - Experts</h2>
                <p class="feature-text">
                    Soft hand feel – printing directly from ink jets onto the garment means a super
                    soft finish and the print feels like it’s part of the garment. A clean finish,
                    is durable and looks great!
                </p>
                <p class="feature-text">
                    Vibrant colours – We only print with the Kornit Avalanche, this market and
                    industry leading bit of kit has 6 print heads each printing individual colours
                    which can produce a super vibrant print recreating almost any colour.
                </p>
                <p class="feature-text">
                    Eco friendly – Our DTG inks are eco-friendly! They are water based, vegan,
                    non-hazardous and bio-degradable.
                </p>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl bg--dk-blue">
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/barclays.png" alt="" />
            </div>
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/google.png" alt="" />
            </div>
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/microsoft.png" alt="" />
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-bottom--xl pad-top bg--dk-blue">
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/bbc.png" alt="" />
            </div>
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/british-gas.png" alt="" />
            </div>
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/bentley.png" alt="" />
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--swoosh-top-left">
            <div class="cell small-12 medium-8 medium-offset-2 text-center">
                <p class="feature-text">
                    <strong>DTG printed t-shirts:</strong><br />
                    Create Customised Clothing now with our personalised online t shirt design tool
                    and with our overnight express shipping service you could receive your order
                    the very next day.
                </p>
                <p class="feature-text">
                    Ideal for small to medium quantity orders Suited to most artwork including full
                    colour designs and photographic imagery Ideal File Formats are .pdf, .eps, .ai,
                    .png, .tif, .jpg (300dpi) Perfect for large and complex designs Not suitable
                    for any garment containing less than 50% cotton.
                </p>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--lilac-dk">
            <div class="cell small-12 medium-6 medium-offset-3">
                <div class="bg--dk-blue pad-top--xxxxl pad-left--xxxl pad-right--xxxl pad-bottom--xxxxl">
                    <h2 class="text-center text-white">Video</h2>
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--swoosh-top-right">
            <div class="cell small-12 medium-8 medium-offset-2 text-center">
                <p class="feature-text">
                    <strong>What's involved:</strong><br />
                    Your design is uploaded to the DTG machine<br />
                    Garments have a pre-treatment spray applied to prevent the ink being printed
                    from migrating into the fabric.<br />
                    The garment is then loaded and the design is printed directly onto the garment<br />
                    Once the garment has been printed it’s then passed through a conveyor drying
                    tunnel, this completely cures any wet ink and completes the process.
                </p>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xxxl pad-bottom--large bg--lilac relative">
            <span class="top-center-badge">
                <img src="../../../static/images/customisation/top-badge.png" alt="" />
            </span>
            <div class="cell small-12">
                <div class="grid-x grid-padding-x">
                    <div class="cell small-12 medium-8 medium-offset-2">
                        <p class="text-center">
                            <span class="button-text">Contact Us</span>
                        </p>
                    </div>
                </div>
                <form v-on:submit="sendContactForm">
                    <div class="grid-x grid-padding-x pad-top">
                        <div class="cell small-12 medium-3 medium-offset-2">
                            <input required v-model="contact.name" class="featured-input" type="text" placeholder="name">
                        </div>
                        <div class="cell small-12 medium-5">
                            <input required v-model="contact.message" class="featured-input" type="text" placeholder="Selection E.g Screen printing">
                        </div>
                    </div>
                    <div class="grid-x grid-padding-x pad-top--small">
                        <div class="cell small-12 medium-4 medium-offset-2">
                            <input required v-model="contact.email" class="featured-input" type="email" placeholder="Email address">
                        </div>
                        <div class="cell small-12 medium-4">
                            <input required v-model="contact.telephone" class="featured-input" type="text" placeholder="Telephone">
                        </div>
                    </div>
                    <div class="grid-x grid-padding-x pad-top">
                        <div class="cell small-12 medium-8 medium-offset-2">
                            <p class="text-center">
                                <button class="button-text link">Send</button>
                            </p>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xxxl pad-bottom--large bg--dk-blue">
            <div class="cell small-12">
                <p class="text-center text-white">
                    <img width="50px" src="../../../static/images/customisation/tel.png" alt="" />
                    &nbsp;0116 467 0260&nbsp;
                    <img width="50px" src="../../../static/images/customisation/mail.png" alt="" />
                    &nbsp;info@customisedclothing.com&nbsp;
                    <img width="50px" src="../../../static/images/customisation/clock.png" alt="" />
                </p>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';
import axios from '../../axios';

export default {
    name: 'DTG',
    metaInfo() {
        return {
            title: 'Customised Clothing: Quick Direct to Garment Printing Services',
            titleTemplate: '%s - Customised Clothing',
            meta: [
                { description: 'DTG printed t shirts are ideal for small to medium orders. Get illustrations and designs printed directly onto garments. Unleash your creativity!' },
            ],
            link: [
                { rel: 'canonical', href: 'https://customisedclothing.com/screenprinting' },
            ],
        };
    },
    data() {
        return {
            contact: {
                name: '',
                email: '',
                message: '',
            },
        };
    },
    methods: {
        sendContactForm(event) {
            event.preventDefault();
            axios.post('/Contacts/addContact.json', this.contact)
                .then(() => {
                    this.$router.push('/contact-thankyou');
                });
        },
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/StaticPages/Dtg.vue